import axios from "axios";
import React from "react";
import BeatLoader from "react-spinners/BeatLoader";
import { Box, Typography } from '@mui/material';
import OfficeVersionTabs from "./OfficeVersionTabs";
import PackageVersionSelector from "./PackageVersionSelector";
import { Package, Office, initData } from "./interfaces";

const baseURL = "https://cleansheet-install.mckinsey-solutions.com/api/data";

export default function Main() {
    const [packages, setPackages] = React.useState<Package[]>([]);
    const [packageVersion, setPackageVersion] = React.useState<string>("");

    const handlePackageVersionChange = (v: string) => {
        setPackageVersion(v);
    }

    const getCurrentOffices = (): Office[] => {
        const currentPackage = packages.find((it) => it.packageVersion === packageVersion);
        return currentPackage?.offices ?? [];
    }

    const getPackageVersions = () => packages.map(({packageVersion}) => packageVersion);

    React.useEffect(() => {
        axios.post(baseURL, {}, {
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem("_mid-id-token")}`,
            }
        }).then((response) => {
            const { initData } = response.data;
            const sortedData = initData.sort((a: Package, b: Package) => {
                const aVersions = a.packageVersion.split(".");
                const bVersions = b.packageVersion.split(".");

                if(Number(aVersions[0]) < Number(bVersions[0])){ return 1; }
                if(Number(aVersions[0]) > Number(bVersions[0])){ return -1; }

                if(Number(aVersions[1]) < Number(bVersions[1])){ return 1; }
                if(Number(aVersions[1]) > Number(bVersions[1])){ return -1; }

                if(Number(aVersions[2]) < Number(bVersions[2])){ return 1; }
                if(Number(aVersions[2]) > Number(bVersions[2])){ return -1; }

                return 0;
            });
            setPackages(sortedData);
            setPackageVersion(sortedData[0].packageVersion);
        }).catch(() => {
            console.log("error");
            setPackages(initData);
            setPackageVersion(initData[0].packageVersion);
        });
    }, []);

    if (packageVersion === "") {
        return (
            <Box sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center"
            }}>
                <Box sx={{
                    width: "20%",
                    marginTop: "20%",
                }}>
                    <BeatLoader color="white" size={30}/>
                </Box>
            </Box>
        );
    }

    if (packageVersion) {
        return (
            <Box display="flex" flexDirection="column" alignItems="center" paddingY={8}>
                <Box>
                    <Typography variant="h2" fontSize="3rem" fontWeight={500} lineHeight="56px">Hello!</Typography>
                    <Typography
                      variant="h4"
                      fontSize="2rem"
                      fontWeight={500}
                      lineHeight="36px"
                      marginTop={1.5}
                      marginBottom={2}
                    >
                        Download Cleansheet package in your Desktop.
                    </Typography>
                    <Typography>
                        On this website, you will find the available packages to update Access Cleansheet in your
                        Desktop.
                    </Typography>
                    <Typography marginTop={2} fontSize="1.5rem">
                        1. Select the Cleansheet version. The latest one is version {packages[0].packageVersion}.
                    </Typography>
                    <Box paddingTop={2.5} paddingBottom={3}>
                        <PackageVersionSelector
                          currentVersion={packageVersion}
                          versions={getPackageVersions()}
                          onVersionChange={handlePackageVersionChange}
                        />
                    </Box>
                    <Typography fontSize="1.5rem">
                        2. Choose your Microsoft Office version and download the package for your computer’s processor.
                    </Typography>
                    <Box borderColor="grey" border={1} borderRadius={2} marginTop={3}>
                        <OfficeVersionTabs offices={getCurrentOffices()}/>
                    </Box>
                </Box>
            </Box>
        )
    }

    return null;
}
